import React, { Suspense } from 'react';

import ContentAreaLoader from 'components/atoms/Loaders/ContentAreaLoader';
import { AppShellContext } from 'context/AppShellContext';

import SuperAdminLayoutShell from './LayoutShell';

const SuperAdminAppShell = ({ children }) => {
  return (
    <AppShellContext.Provider value={true}>
      <SuperAdminLayoutShell>
        <Suspense fallback={<ContentAreaLoader />}>{children}</Suspense>
      </SuperAdminLayoutShell>
    </AppShellContext.Provider>
  );
};

export default SuperAdminAppShell;
